import api from './api';

export const storyAPI = {
  // Get all active stories
  getStories: (params = {}) => {
    return api.get('/stories', { params });
  },

  // Get single story
  getStory: (id) => {
    return api.get(`/stories/${id}`);
  },

  // Create story
  createStory: (data) => {
    return api.post('/stories', data);
  },

  // Delete story
  deleteStory: (id) => {
    return api.delete(`/stories/${id}`);
  },

  // React to story
  reactToStory: (id, reactionType) => {
    return api.post(`/stories/${id}/react`, { reaction_type: reactionType });
  },

  // Remove reaction
  removeReaction: (id) => {
    return api.delete(`/stories/${id}/react`);
  },

  // Get my reaction
  getMyReaction: (id) => {
    return api.get(`/stories/${id}/reaction`);
  },

  // Record view
  recordView: (id) => {
    return api.post(`/stories/${id}/view`);
  },

  // Reply to story
  replyToStory: (id, message) => {
    return api.post(`/stories/${id}/reply`, { message });
  },

  // Upload media
  uploadMedia: (formData, type) => {

    return api.post('/media/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      params: { type },
    });
  },
};

export default storyAPI;
